import React from 'react';
import styled from 'styled-components';
import { Dimmer, Icon, Loader } from 'semantic-ui-react';
import { getScrollBarStyles } from '../../../config/styles';
import { theme } from '../../../styles/theme';
import { newMessageButtonWidth } from './utils';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #f2f5fc;
  border: 1px solid #e5e5e5;
`;

export const LoaderContaier = styled(Dimmer)`
  &&& {
    background: transparent;
  }
`;

export const MessageContainer = styled.div``;
export const SplitterContainer = styled.div`
  display: inline-flex;
  padding: 12px 0;
  width: 100%;
`;
export const DateSeparate = styled(({ isNewMessage, ...props }) => (
  <div {...props} />
))`
  width: 100px;
  height: 1px;
  background-color: ${({ isNewMessage }) =>
    isNewMessage ? theme.colors.mainBlue : '#626266'};
  top: 10px;
  opacity: 0.2;
  position: relative;
`;
export const CreatedDate = styled(({ isNewMessage, ...props }) => (
  <div {...props} />
))`
  font-size: 12px;
  padding: 0;
  font-weight: 500;
  color: ${({ isNewMessage }) =>
    isNewMessage ? theme.colors.mainBlue : '#626266'};
  position: relative;
  width: fit-content;
  margin: auto;
`;

export const UnreadSeparate = styled.div`
  width: 165px;
  height: 1px;
  background-color: ${theme.colors.mainBlue};
  top: 10px;
  position: relative;
  float: left;
`;

export const NewMessageFlag = styled.div`
  padding-left: 12px;
  font-size: 12px;
  font-weight: 500;
  color: ${theme.colors.mainBlue};
  float: right;
`;

export const ChatContent = styled.div`
  overflow: auto;
  flex-grow: 1;
  position: relative;
  ${getScrollBarStyles(4)}
`;

export const MessageInfo = styled.div``;

export const NewMessageButton = styled.div`
  background: linear-gradient(
    71deg,
    #123456 -30%,
    ${theme.colors.mainBlue} 90%
  );
  width: ${newMessageButtonWidth}px;
  height: 24px;
  border-radius: 18px;
  box-shadow: 0 2px 4px 0 rgba(0, 118, 234, 0.2);
  padding: 2px;
  position: fixed;
  cursor: pointer;
  z-index: 1;
`;

export const ArrowDownIcon = styled(Icon)`
  &&& {
    color: #ffffff;
    width: 14px;
    height: 14px;
    float: left;
    margin-left: 8px;
    padding-top: 2px;
  }
`;

export const NewMessageText = styled.div`
  color: #ffffff;
  font-size: 12px;
  float: right;
  margin-right: 8px;
`;

export const LazyLoader = styled((props) => (
  <div {...props}>
    <Loader active size="medium" />
  </div>
))`
  position: relative;
  min-height: 32px;
  margin-top: 12px;
`;

export const StyledLoader = styled(Loader)``;
